import { jsx as O } from "@emotion/react/jsx-runtime";
import { useReducer as T, useState as w, useEffect as b, useMemo as U, createContext as j, useContext as q } from "react";
import { buildApiResources as A } from "./helpers/api.js";
import { getFiltersOnReset as I } from "./helpers/getFiltersOnReset.js";
import { computePersistentFilterKeysOnReset as N, convertFiltersToPreFiltersGroups as _, convertFiltersToPreFilters as C } from "./helpers/normalizr.js";
import { businessModalFiltersReducer as k, createFreshInitialState as z } from "./reducer/businessModal.reducer.js";
import { resetSelection as M } from "./reducer/businessModal.actions.js";
import { SelectionType as D } from "./reducer/businessModal.types.js";
const R = j(void 0), Z = () => {
  const e = q(R);
  if (!e)
    throw new Error("useBusinessModalContext must be used within a BusinessModalProvider");
  return e;
}, P = {
  all: {
    displayGroups: !0,
    displayBusinesses: !0
  },
  groupOnly: {
    displayGroups: !0,
    displayBusinesses: !1
  },
  businessOnly: {
    displayGroups: !1,
    displayBusinesses: !0
  }
}, $ = ({
  open: e,
  setOpen: n,
  filters: s = {},
  setFilters: i,
  readOnlyFilters: c = {},
  apiBaseUrl: S = "",
  variant: o = "all",
  translations: l,
  children: g,
  filterVisibility: r = {
    query: !0,
    city: !0,
    org_id: !0
  },
  persistentFilterKeysOnReset: u = []
}) => {
  const v = N(u, r), p = o === "groupOnly" ? _(s) : C(s, v), [a, t] = T(k, z(p)), [d, m] = w({}), {
    displayGroups: y,
    displayBusinesses: f
  } = P[o] || P.all, B = A(S), E = () => {
    t(M(p));
  }, F = () => {
    const h = I({
      filters: s,
      persistentFilterKeysOnReset: u
    }), x = C(h);
    t(M({
      ...x,
      selection: {
        ...x.selection,
        type: D.UNSET
      }
    }));
  };
  b(() => {
    E();
  }, [s, e, u]);
  const G = U(() => ({
    open: e,
    setOpen: n,
    filters: s,
    setFilters: i,
    readOnlyFilters: c,
    error: d,
    setError: m,
    preFilters: a,
    variant: o,
    apiClient: B,
    displayBusinesses: f,
    displayGroups: y,
    dispatch: t,
    translations: l,
    filterVisibility: r,
    resetState: F
  }), [e, n, s, i, c, d, m, a, t, B, f, y, l, r, F]);
  return /* @__PURE__ */ O(R.Provider, { value: G, children: g });
};
export {
  $ as BusinessModalProvider,
  Z as useBusinessModalContext
};
